import { render, staticRenderFns } from "./defaultSelect.vue?vue&type=template&id=a4f66018"
import script from "./defaultSelect.vue?vue&type=script&lang=js"
export * from "./defaultSelect.vue?vue&type=script&lang=js"
import style0 from "./defaultSelect.vue?vue&type=style&index=0&id=a4f66018&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports